module.exports = __webpack_public_path__ + "img/background.21fe1aba.jpg";